import React from 'react';

export interface BooleanDisplayProps {
    value: boolean | null | undefined;
}

export const BooleanDisplay: React.FC<BooleanDisplayProps> = ({ value }) => {
    if (value == null) {
        return <>N/A</>;
    } else if (value === true) {
        return <>Yes</>;
    }

    return <>No</>;
};
